import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
export const DailyWiseReport=() =>{
  
  return (
    <>
    <MainDiv>
    {/* <MainContent/>         */}
    <DateWiseSearch />
   </MainDiv> 
    </>
    
  )
}
